@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package hotelos.shared.ui.designsystem.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val ic_admin: DrawableResource by 
      lazy { init_ic_admin() }

  public val ic_finance: DrawableResource by 
      lazy { init_ic_finance() }

  public val ic_housekeeping: DrawableResource by 
      lazy { init_ic_housekeeping() }

  public val ic_inventory: DrawableResource by 
      lazy { init_ic_inventory() }

  public val ic_logo: DrawableResource by 
      lazy { init_ic_logo() }

  public val ic_logo_white: DrawableResource by 
      lazy { init_ic_logo_white() }

  public val ic_logout: DrawableResource by 
      lazy { init_ic_logout() }

  public val ic_pos: DrawableResource by 
      lazy { init_ic_pos() }

  public val ic_reports: DrawableResource by 
      lazy { init_ic_reports() }

  public val ic_reservation: DrawableResource by 
      lazy { init_ic_reservation() }

  public val ic_room_management: DrawableResource by 
      lazy { init_ic_room_management() }

  public val ic_staff: DrawableResource by 
      lazy { init_ic_staff() }

  public val img_hotel_lobby_hero: DrawableResource by 
      lazy { init_img_hotel_lobby_hero() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_admin", CommonMainDrawable0.ic_admin)
  map.put("ic_finance", CommonMainDrawable0.ic_finance)
  map.put("ic_housekeeping", CommonMainDrawable0.ic_housekeeping)
  map.put("ic_inventory", CommonMainDrawable0.ic_inventory)
  map.put("ic_logo", CommonMainDrawable0.ic_logo)
  map.put("ic_logo_white", CommonMainDrawable0.ic_logo_white)
  map.put("ic_logout", CommonMainDrawable0.ic_logout)
  map.put("ic_pos", CommonMainDrawable0.ic_pos)
  map.put("ic_reports", CommonMainDrawable0.ic_reports)
  map.put("ic_reservation", CommonMainDrawable0.ic_reservation)
  map.put("ic_room_management", CommonMainDrawable0.ic_room_management)
  map.put("ic_staff", CommonMainDrawable0.ic_staff)
  map.put("img_hotel_lobby_hero", CommonMainDrawable0.img_hotel_lobby_hero)
}

public val Res.drawable.ic_admin: DrawableResource
  get() = CommonMainDrawable0.ic_admin

private fun init_ic_admin(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_admin",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_admin.png", -1, -1),
    )
)

public val Res.drawable.ic_finance: DrawableResource
  get() = CommonMainDrawable0.ic_finance

private fun init_ic_finance(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_finance",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_finance.png", -1, -1),
    )
)

public val Res.drawable.ic_housekeeping: DrawableResource
  get() = CommonMainDrawable0.ic_housekeeping

private fun init_ic_housekeeping(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_housekeeping",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_housekeeping.png", -1, -1),
    )
)

public val Res.drawable.ic_inventory: DrawableResource
  get() = CommonMainDrawable0.ic_inventory

private fun init_ic_inventory(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_inventory",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_inventory.png", -1, -1),
    )
)

public val Res.drawable.ic_logo: DrawableResource
  get() = CommonMainDrawable0.ic_logo

private fun init_ic_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_logo.png", -1, -1),
    )
)

public val Res.drawable.ic_logo_white: DrawableResource
  get() = CommonMainDrawable0.ic_logo_white

private fun init_ic_logo_white(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_logo_white",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_logo_white.png", -1, -1),
    )
)

public val Res.drawable.ic_logout: DrawableResource
  get() = CommonMainDrawable0.ic_logout

private fun init_ic_logout(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_logout",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_logout.png", -1, -1),
    )
)

public val Res.drawable.ic_pos: DrawableResource
  get() = CommonMainDrawable0.ic_pos

private fun init_ic_pos(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_pos",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_pos.png", -1, -1),
    )
)

public val Res.drawable.ic_reports: DrawableResource
  get() = CommonMainDrawable0.ic_reports

private fun init_ic_reports(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_reports",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_reports.png", -1, -1),
    )
)

public val Res.drawable.ic_reservation: DrawableResource
  get() = CommonMainDrawable0.ic_reservation

private fun init_ic_reservation(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_reservation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_reservation.png", -1, -1),
    )
)

public val Res.drawable.ic_room_management: DrawableResource
  get() = CommonMainDrawable0.ic_room_management

private fun init_ic_room_management(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_room_management",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_room_management.png", -1, -1),
    )
)

public val Res.drawable.ic_staff: DrawableResource
  get() = CommonMainDrawable0.ic_staff

private fun init_ic_staff(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_staff",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/ic_staff.png", -1, -1),
    )
)

public val Res.drawable.img_hotel_lobby_hero: DrawableResource
  get() = CommonMainDrawable0.img_hotel_lobby_hero

private fun init_img_hotel_lobby_hero(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:img_hotel_lobby_hero",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/hotelos.shared.ui.designsystem.generated.resources/drawable/img_hotel_lobby_hero.jpg", -1, -1),
    )
)
